module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vbl-tab-group"
  }, [_c('ul', {
    staticClass: "tab-title"
  }, _vm._l((_vm.tabs), function(tabItem, index) {
    return _c('li', {
      class: {
        'is-active': _vm.dataSelectedIndex === index
      },
      on: {
        "click": function($event) {
          _vm.dataSelectedIndex = index
        }
      }
    }, [_vm._v("\n            " + _vm._s(tabItem.label) + "\n        ")])
  })), _c('div', {
    staticClass: "tab-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5033cab4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblTab/src/vblTabGroup.vue
// module id = 266
// module chunks = 0